import { ADD_FORMS, FormsActionType,DELETE_FORMS ,UPDATE_FORMS} from "./types";


export function addFroms(data: any): FormsActionType {
    return {
        type: ADD_FORMS,
        data: data
    }
}

export function deleteForm(data: any): FormsActionType {
    return {
        type: DELETE_FORMS,
        data: data
    }
}
 
 export function updateForms(data:any):FormsActionType{
    return {
        type: UPDATE_FORMS,
        data: data
    }
 }

